import React from 'react';
import Skeleton, { SkeletonArea, SkeletonCartao } from './Skeleton';

/**
 * Esqueleto neutro enquanto o chunk da rota baixa.
 *
 * Não imita nenhuma tela específica de propósito: aqui o app ainda não sabe o
 * que vai renderizar, e um layout errado piscando por 200ms é pior que um bloco
 * genérico. O skeleton de cada tela, esse sim com a forma certa, mora na tela.
 */
export default function RouteSkeleton() {
  return (
    <SkeletonArea className="min-h-screen bg-cream dark:bg-gray-950 px-5 pt-14 pb-24 flex flex-col gap-3">
      <Skeleton className="h-7 w-40" />
      <Skeleton className="h-4 w-56" />
      <div className="flex flex-col gap-3 mt-4">
        <SkeletonCartao />
        <SkeletonCartao />
        <SkeletonCartao />
      </div>
    </SkeletonArea>
  );
}
